export default {
  getSelfieApproved: (state) => state.selfieApproved,
  getSelfieKey: (state) => state.selfieKey,
};
